<template>
  <div class="container-fluid">
    <nav v-if="!load & !embed" class="navbar navbar-expand-lg navbar-light mb-3 navbar__filters">
      <div class="navbar" id="filters">
        <span>
          <button
            v-if="events.length !== 0"
            type="button"
            class="btn btn-outline-info btn__full"
            data-toggle="modal"
            data-target="#salas_check"
            @click="showRoomsSelector = true"
          >
            <span v-if="$route.params.language === 'pt'">Salas</span>
            <span v-if="$route.params.language === 'en'">Rooms</span>
            <span v-if="$route.params.language === 'es'">Salas</span>
          </button>

          <router-link
            tag="a"
            :to="{ name: 'tracks' }"
            class="btn btn-outline-info btn__full"
          >Fóruns</router-link>

          <router-link tag="a" :to="{ name: 'speakers' }" class="btn btn-outline-info btn__full">
            <span v-if="$route.params.language === 'pt'">Palestrantes</span>
            <span v-if="$route.params.language === 'en'">Speakers</span>
            <span v-if="$route.params.language === 'es'">Palestrantes</span>
          </router-link>

          <a
            class="btn btn-outline-info btn__full"
            :href="`https://congresso.easyevent.com.br/pdf/85128089-0970-44fe-81d3-f902376b1651/slots-day/${$route.params.day}/${$route.params.language}`"
            target="_blank"
          >PDF</a>
        </span>

        <!-- MODAL SALAS HABILITADAS -->
        <div
          v-show="showRoomsSelector"
          class="modal fade"
          id="salas_check"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  <span v-if="$route.params.language === 'pt'">Selecione as Salas</span>
                  <span v-if="$route.params.language === 'en'">Select the rooms</span>
                  <span v-if="$route.params.language === 'es'">Selecione las Salas</span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p v-if="$route.params.language === 'pt'">Selecione as salas que deseja visualizar</p>
                <p v-if="$route.params.language === 'en'">Select the rooms you want to view</p>
                <p v-if="$route.params.language === 'es'">Seleccione las habitaciones que desea ver.</p>
                <ul class="list-group">
                  <li
                    v-for="room in rooms"
                    :key="room.id"
                    class="list-group-item room__check check"
                    v-if="roomHasEvents(room.id)"
                  >
                    <label class="check__label w__full">
                      <span v-if="room.name_by_day">{{ room.name_by_day.name }}</span>
                      <span v-else>{{ room.name }}</span>
                      <input type="checkbox" :id="room.id" :value="room.id" v-model="checked" />
                      <div class="check__body">
                        <div class="check__slide"></div>
                      </div>
                    </label>
                  </li>
                </ul>
                <div data-dismiss="modal" class="d-flex justify-content-end mt-2">
                  <button class="btn btn-outline-primary" @click="selectRooms">
                    <span v-if="$route.params.language === 'pt'">Aplicar</span>
                    <span v-if="$route.params.language === 'en'">Apply</span>
                    <span v-if="$route.params.language === 'es'">Aplicar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-inline my-2 my-lg-0">
          <div class="form-group search__group">
            <input
              class="form-control mr-sm-2"
              type="search"
              v-model="filter"
              v-on:keyup.enter="goToSearch"
              aria-label="Search"
            />
            <button class="btn btn-outline-success my-sm-0" @click="goToSearch">
              <span v-if="$route.params.language === 'pt'">Buscar</span>
              <span v-if="$route.params.language === 'en'">Search</span>
              <span v-if="$route.params.language === 'es'">Buscar</span>
            </button>
            <div v-if="alertSearch" class="alert alert-danger alert__search">
              <span v-if="$route.params.language === 'pt'">Inserir 2 ou mas letras</span>
              <span v-if="$route.params.language === 'en'">Enter 2 or more letters</span>
              <span v-if="$route.params.language === 'es'">Ingresa 2 o mas letras</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div v-if="load" class="text-center text-secondary mt-5 mb-3">
      <i class="fas fa-3x fa-spinner fa-pulse"></i>
      <br />
      <span v-if="$route.params.language === 'pt'">Carregando ...</span>
      <span v-if="$route.params.language === 'en'">Loading...</span>
      <span v-if="$route.params.language === 'es'">Carregando...</span>
    </div>
    <div v-if="!load" class="container-fluid" style="padding-left: 0px; padding-right: 0px">
      <h2 class="h1 head__title">
        <span v-if="$route.params.language === 'pt'">Dia {{ $route.params.day }}/10</span>
        <span v-if="$route.params.language === 'en'">Day 10/{{ $route.params.day }}</span>
        <span v-if="$route.params.language === 'es'">Día {{ $route.params.day }}/10</span>
        <!-- <small class="text-muted">{{ week($route.params.language, $route.params.day) }}</small> -->
        <small class="text-muted" v-if="roomInfo">{{ roomInfo.name }}</small>

        <div class="convens">
          <div class="conven">
            <span class="conven__pay"></span>
            <span class="convent__tx" v-if="$route.params.language === 'pt'">Conteúdo Pago</span>
            <span class="convent__tx" v-if="$route.params.language === 'en'">Paid Content</span>
            <span class="convent__tx" v-if="$route.params.language === 'es'">Contenido pagado</span>
          </div>
          <div class="conven">
            <span class="conven__free"></span>
            <span class="convent__tx" v-if="$route.params.language === 'pt'">Conteúdo Livre</span>
            <span class="convent__tx" v-if="$route.params.language === 'en'">Free Content</span>
            <span class="convent__tx" v-if="$route.params.language === 'es'">Contenido libre</span>
          </div>
        </div>

        <!-- <span class="float-right box__move">
          <i class="fas fa-long-arrow-alt-left"></i>
          <small
            class="information-slide"
            v-if="$route.params.language === 'pt'"
          >segure e arraste para ver programação</small>
          <small
            class="information-slide"
            v-if="$route.params.language === 'en'"
          >hold and drag to see schedule</small>
          <small
            class="information-slide"
            v-if="$route.params.language === 'es'"
          >sostenga y arrastre para ver el horario</small>
          <i class="fas fa-long-arrow-alt-right"></i>
        </span>-->
      </h2>

      <div v-if="!load && events.length < 1" class="alert alert-warning mt-3" role="alert">
        <span v-if="$route.params.language === 'pt'">Nenhum evento encontrado</span>
        <span v-if="$route.params.language === 'en'">No event found</span>
        <span v-if="$route.params.language === 'es'">Ningún evento encontrado</span>
      </div>

      <div class="main" v-if="!load && events.length !== 0">
        <!-- <div
          class="arrow-left"
          v-if="horizontal > 0"
          @mouseover="scrollHorizontalLeft"
          @click="scrollHorizontalLeft"
        >
          <i class="fas fa-long-arrow-alt-left"></i>
        </div>
        <div class="arrow-right" @mouseover="scrollHorizontalRight" @click="scrollHorizontalRight">
          <i class="fas fa-long-arrow-alt-right"></i>
        </div>-->
        <div class="row rooms" id="rooms" @scroll.passive="getHorizontalScroll">
          <div
            class="room"
            v-for="room in roomsChecked"
            :key="room.id"
            v-if="roomHasEvents(room.id)"
          >
            <span class="room__name">
              <span
                class="room__access"
                :class="{ 'free' : room.free_access, 'pay' : !room.free_access}"
              ></span>
              <span v-if="room.name_by_day">{{ room.name_by_day.name }}</span>
              <span v-else>{{ room.name }}</span>
            </span>

            <SlotEvent
              v-for="(event, index) in events[room.id]"
              :key="event.slot_id"
              :time="index"
              :event="event"
              @selectEvent="eventSelected = $event"
            />
          </div>
        </div>
      </div>

      <EventInfo :event="eventSelected" />
    </div>
  </div>
</template>
<script>
import { eventBus } from "../main";
import SlotEvent from "./event/SlotEvent.vue";
import EventInfo from "./event/EventInfo.vue";
import json from "../data/day16.json";
import { HTTP } from "../axios";
var _ = require("lodash");
export default {
  name: "Events",
  data() {
    return {
      times: {},
      events: {},
      rooms: {},
      roomInfo: null,
      filter: "",
      list: [],
      eventsSearch: {},
      load: true,
      seeMore: {},
      eventSelected: undefined,
      checked: [],
      alertSearch: false,
      roomsChecked: [],
      tracks: [],
      horizontal: null,
      showRoomsSelector: false
    };
  },
  watch: {
    day() {
      this.getSlots();
      this.getRooms();
    },
    $route(day, language) {
      this.getSlots();
      this.getRooms();
    },
    checked() {
      // const room = JSON.stringify(this.checked);
      // this.$router.push({ query: { rooms: room } });
      // this.getRoomsChecked();
    },
    load() {
      this.postMsg();
    }
  },
  computed: {
    hasSeach() {
      if (this.eventsSearch.length > 0) {
        return true;
      }
      return false;
    },
    embed() {
      if (this.$route.query.embed === "true") {
        return true;
      }
      return false;
    }
  },
  methods: {
    roomHasEvents(id) {
      if (this.events[id] != undefined) {
        return true;
      }
      return false;
    },
    teste() {
      this.$router.push({ query: { rooms: "Alohaa" } });
    },
    getHorizontalScroll() {
      this.horizontal = document.getElementById("rooms").scrollLeft;
    },
    scrollHorizontalLeft() {
      var container = document.getElementById("rooms");
      this.sideScroll(container, "left", 25, 100, 10);
    },
    scrollHorizontalRight() {
      var container = document.getElementById("rooms");
      this.sideScroll(container, "right", 25, 100, 10);
    },
    sideScroll(element, direction, speed, distance, step) {
      var scrollAmount = 0;
      var slideTimer = setInterval(function() {
        if (direction == "left") {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    },
    setQueryParams() {
      this.$router.push({ query: { rooms: JSON.stringify(this.checked) } });
    },
    selectRooms() {
      this.getRoomsChecked();
      this.setQueryParams();
    },
    getRoomsChecked() {
      this.roomsChecked = [];
      for (let index = 0; index < this.rooms.length; index++) {
        if (this.checked.indexOf(this.rooms[index].id) >= 0) {
          this.roomsChecked.push(this.rooms[index]);
        }
      }
    },
    getRoomId(rooms, checked) {
      if (!rooms) {
        console.log("Nao tem salas registradas");
      } else {
        if (this.$route.query.rooms) {
          this.checked = JSON.parse(this.$route.query.rooms);
        } else {
          for (let index = 0; index < rooms.length + 1; index++) {
            if (rooms[index]) {
              this.checked.push(rooms[index].id);
            }
          }
        }
        this.getRoomsChecked();
      }
    },
    getRoomName() {
      const routeNow = this.$route.params.room;
      if (routeNow) {
        const index = _.findIndex(this.rooms, function(o) {
          return o.slug === routeNow;
        });
        console.log("index: ", index);
        this.roomInfo = this.rooms[index];
      } else {
        this.roomInfo = null;
      }
    },
    week(lang, day) {
      if (lang === "pt") {
        if (day === 15) {
          return "Segunda Feira";
        }
        if (day === 16) {
          return "Terça Feira";
        }
        if (day === 17) {
          return "Quarta Feira";
        }
        if (day === 18) {
          return "Quinta Feira";
        }
      }
      if (lang === "en") {
        if (day === 15) {
          return "Monday";
        }
        if (day === 16) {
          return "Tuesday";
        }
        if (day === 17) {
          return "Wednesday";
        }
        if (day === 18) {
          return "Thursday";
        }
      }
      if (lang === "es") {
        if (day === 15) {
          return "Lunes";
        }
        if (day === 16) {
          return "Martes";
        }
        if (day === 17) {
          return "Miércoles";
        }
        if (day === 18) {
          return "Jueves";
        }
      }
    },
    cleanData(dados) {
      this.list.push(dados);
    },
    getSlots() {
      this.load = true;
      if (this.$route.params.room) {
        this.getSlotsRoom();
      } else {
        this.roomInfo = null;
        this.getSlotsFull();
      }
    },
    getTracks() {
      console.log("test tracks");
      this.load = true;
      HTTP.get(
        "get-event-tracks/85128089-0970-44fe-81d3-f902376b1651/" +
          this.$route.params.language
      ).then(response => {
        this.tracks = response.data;
        this.load = false;
      });
    },
    getSlotsFull() {
      HTTP.get(
        "grid-agenda-v2/85128089-0970-44fe-81d3-f902376b1651/slots-day/" +
          this.$route.params.day +
          "/" +
          this.$route.params.language
      ).then(response => {
        this.events = response.data;
        this.load = false;
        //console.log( this.events.length )
        if (this.events.length > 0) {
          setTimeout(() => {
            this.dragEvents();
          }, 1000);
        }
      });
    },
    getSlotsRoom() {
      HTTP.get(
        "grid-agenda-v2/85128089-0970-44fe-81d3-f902376b1651/slots-day/" +
          this.$route.params.day +
          "/" +
          this.roomInfo.id +
          "/" +
          this.$route.params.language
      ).then(response => {
        this.events = response.data;
        this.load = false;
      });
    },
    getRooms() {
      this.load = true;
      HTTP.get(
        `get-rooms-by-day/85128089-0970-44fe-81d3-f902376b1651/${this.$route.params.day}/${this.$route.params.language}`
      ).then(response => {
        this.rooms = response.data;
        this.getRoomName();
        this.getSlots();
        this.load = false;
        this.getRoomId(response.data);
      });
    },
    goToSearch() {
      if (this.filter.length >= 2) {
        window.location.href =
          "/search/" + this.$route.params.language + "/" + this.filter;
      } else {
        return (this.alertSearch = true);
      }
    },
    dragEvents() {
      const slider = document.querySelector(".rooms");
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener("mousedown", e => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
        //console.log(walk)
      });
    },
    postMsg() {
      var body = document.body,
        html = document.documentElement;
      var height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      if (parent !== self) {
        parent.postMessage(height, "*");
        // parent.postMessage({ height: height, load: true }, "*");
      }
    }
  },
  components: {
    SlotEvent,
    EventInfo
  },
  mounted() {
    this.getRooms();
    this.getTracks();
    this.postMsg();
  },
  updated() {
    if (this.rooms.length > 0) {
      this.rooms.forEach(element => {
        if (this.events[element.id]) {
          if (this.events[element.id].length > 0) {
            this.dragEvents();
          }
        }
      });
    }
  },
  created() {
    eventBus.$on("selectEvent", eventSelected => {
      this.eventSelected = eventSelected;
    });
  }
};
</script>

<style lang="scss" scoped>
.arrow-right {
  right: 0px;
  -webkit-border-top-left-radius: 200px;
  -webkit-border-bottom-left-radius: 200px;
  -moz-border-radius-topleft: 200px;
  -moz-border-radius-bottomleft: 200px;
  border-top-left-radius: 200px;
  border-bottom-left-radius: 200px;
}
.arrow-left {
  left: 0px;
  -webkit-border-top-right-radius: 200px;
  -webkit-border-bottom-right-radius: 200px;
  -moz-border-radius-topright: 200px;
  -moz-border-radius-bottomright: 200px;
  border-top-right-radius: 200px;
  border-bottom-right-radius: 200px;
}
.arrow-right,
.arrow-left {
  top: 50%;
  position: fixed;
  min-width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.arrow-right:hover,
.arrow-left:hover {
  background: rgba(0, 0, 0, 0.6);
}
.arrow-right i,
.arrow-left i {
  animation-duration: 1s;
  animation-name: slidein;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  color: #fff;
}
.time-group {
  background: url("../assets/images/stripes-light.png");
  border-color: #dadada !important;
}
.time-event {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
}
@media (max-width: 1199.98px) {
  .time-group {
    border-color: transparent !important;
    background: transparent;
  }
}
.check {
  padding: 6px 12px;
  &__label {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    input[type="checkbox"] {
      display: none;
    }
  }
  &__body {
    position: relative;
    width: 30px;
    height: 18px;
    background-color: #ccc;
    display: inline-block;
    border-radius: 9px;
    -webkit-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    -moz-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
  }
  &__slide {
    position: absolute;
    top: 0;
    left: -3px;
    width: 18px;
    height: 18px;
    background-color: #fff;
    border-radius: 50%;
    -webkit-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    -moz-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
  }
}
input[type="checkbox"]:checked + .check__body {
  background-color: #4ae086;
  .check__slide {
    left: inherit;
    right: -3px;
  }
}

.btn.btn-success.btn-sm {
  color: #fff;
  font-weight: bold;
  margin: 10px 0 0 0;
}

.main {
  grid-area: main;
  padding: 0;
  overflow-x: scroll;
  overflow-y: hidden;
}
.navbar__filters {
  background-color: #e2e2ec;
  border-radius: 9px;
}
.head__title {
  color: #f1f1f1;
  font-size: 22px;
  font-weight: bold;
  margin: 0;
  padding: 9px 12px;
  border-radius: 9px 9px 0 0;
  background-color: #343a40 !important;
  @media (max-width: 575.98px) {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
  }
}
.rooms {
  overflow: auto;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  white-space: nowrap;
  scroll-margin-top: alert;
  position: relative;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: all 0.2s;
  will-change: transform;
  user-select: none;
  margin: 0;
  cursor: pointer;

  &.active {
    background: rgba(255, 255, 255, 0.3);
    cursor: grabbing;
    cursor: -webkit-grabbing;
  }
}
.room {
  width: 100%;
  min-width: 250px;
  max-width: 50%;
  display: inline-block;
  background-color: #f1f1f1;
  padding-left: 9px;
  padding-right: 9px;

  &__access {
    width: 10px;
    min-width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 50%;
    margin: 0 6px 0 0;

    &.free {
      background-color: #4ae086;
    }
    &.pay {
      background-color: #de636f;
    }
  }

  &__name {
    font-size: 12px;
    line-height: 1;
    padding: 6px;
    text-align: center;
    width: 100%;
    height: 36px;
    display: flex;
    background-color: #ccc;
    margin: 5px 0 -5px 0;
    border-radius: 5px 5px 0 0;
    white-space: normal;
    justify-content: center;
    align-items: center;
  }
}
.room:nth-child(2n) {
  background-color: #e8e8e8;
}
.room__check {
  padding: 0;
  label {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 9px;
    margin: 0;
  }
}
#filters {
  width: 100%;
}
.search__group {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}
.alert__search {
  position: absolute;
  bottom: -75px;
  width: 100%;
  text-align: center;
}
@media (max-width: 575.98px) {
  .btn__full {
    width: 100%;
  }
  .form-inline {
    width: 100%;
  }
}
.box__move {
  // width: 90px;
  width: 360px;
  display: flex;
  justify-content: space-between;
}
.hand__move {
  animation-duration: 1s;
  animation-name: slidein;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes slidein {
  from {
    width: 5px;
  }
  to {
    width: 40px;
  }
}
.convens {
  display: inline-block;
  margin: 0 32px;
  @media (max-width: 575.98px) {
    text-align: center;
    width: 100%;
    margin: 0 0 12px 0;
  }

  .conven {
    display: inline-block;
    font-size: 14px;
    padding: 0 6px;
    &__pay {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #de636f;
    }
    &__free {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #4ae086;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Schedules.vue